import { render, staticRenderFns } from "./TimeRelative.vue?vue&type=template&id=3ed07349"
import script from "./TimeRelative.vue?vue&type=script&lang=js"
export * from "./TimeRelative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports